/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileOff = createReactComponent("file-off", "IconFileOff", [
  ["path", { d: "M3 3l18 18", key: "svg-0" }],
  [
    "path",
    {
      d: "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14",
      key: "svg-1"
    }
  ]
]);

export { IconFileOff as default };
//# sourceMappingURL=IconFileOff.js.map
